

export const sidebarApps = [
  {
    icon: 'product',
    label: 'Products',
  },
  // {
  //   icon: 'componentsearch',
  //   label: 'Component Search',
  //   items: [
  //     { id: '10-ohm-resistor', title: '10 Ohm resistor', content: 'Component Search Interface', contentType: 'componentSearch' },
  //   ]
  // },
  {
    icon: 'thread',
    label: 'Chats',
  },
  // {
  //   icon: 'component',
  //   label: 'Components'
  // },
  // {
  //   icon: 'supplier',
  //   label: 'Suppliers',
  // },
]

